<template>
  <SaltCard inset class="shortcut-settings-panel" aria-label="快捷键设置">
    <template #heading><div class="shortcut-heading"><span>快捷键</span><SaltButton style-type="plain" size="small" :disabled="shortcutSettings.busy" @click="reset">恢复默认</SaltButton></div></template>
    <p v-if="shortcutSettings.error" class="shortcut-error" role="status">{{ shortcutSettings.error }}</p>
    <SaltItem v-for="item in shortcutActions" :key="item.id" :title="item.label" :description="item.description">
      <template #trailing><SaltButton style-type="subtle" :disabled="shortcutSettings.busy" :aria-label="'设置' + item.label" @click="begin(item.id)">{{ recording === item.id ? '请按键…' : bindingLabel(shortcutSettings.bindings[item.id]) }}</SaltButton></template>
    </SaltItem>
    <SaltItem title="保存位置" description="默认保存到此浏览器；登录账号后可选择云端同步。">
      <template #trailing><SaltSelect aria-label="快捷键保存位置" :value="shortcutSettings.storage" :disabled="shortcutSettings.busy" @change="changeStorage"><option value="local">此浏览器本地</option><option value="cloud" :disabled="!site.user">云端账号{{ site.user ? '' : '（请先登录）' }}</option></SaltSelect></template>
    </SaltItem>
  </SaltCard>
</template>
<script>
import SaltCard from '../salt/ui/SaltCard.vue';
import SaltItem from '../salt/ui/SaltItem.vue';
import SaltButton from '../salt/ui/SaltButton.vue';
import SaltSelect from '../salt/ui/SaltSelect.vue';
import { shortcutActions, shortcutSettings, bindingLabel, setShortcut, resetShortcuts, setShortcutStorage } from '../shortcut-settings';
import { siteAccount } from '../site-account';
export default {
  name: 'ShortcutSettingsPanel', components: { SaltCard, SaltItem, SaltButton, SaltSelect },
  data() { return { shortcutActions, shortcutSettings, site: siteAccount, recording: '' }; },
  methods: {
    bindingLabel,
    begin(action) { this.recording = action; this.$el.dataset.shortcutRecording = 'true'; this.$nextTick(() => this.$el.querySelector(`[aria-label="设置${shortcutActions.find(item => item.id === action)?.label}"]`)?.focus()); },
    async capture(event) {
      if (!this.recording) return;
      if (['Control','Meta','Alt','Shift'].includes(event.key)) return;
      event.preventDefault(); event.stopPropagation();
      const action = this.recording; this.recording = ''; delete this.$el.dataset.shortcutRecording;
      await setShortcut(action, { code: event.code, key: event.key, ctrl: event.ctrlKey, meta: event.metaKey, shift: event.shiftKey, alt: event.altKey });
    },
    reset() { resetShortcuts(); this.recording = ''; delete this.$el.dataset.shortcutRecording; },
    changeStorage(value) { setShortcutStorage(value); },
    blurRecording(event) { if (this.recording && !this.$el.contains(event.relatedTarget)) { this.recording = ''; delete this.$el.dataset.shortcutRecording; } },
  },
  mounted() { this.$el.addEventListener('keydown', this.capture, true); this.$el.addEventListener('focusout', this.blurRecording); },
  beforeDestroy() { this.$el.removeEventListener('keydown', this.capture, true); this.$el.removeEventListener('focusout', this.blurRecording); },
};
</script>
<style scoped>
.shortcut-heading { display:flex; align-items:center; justify-content:space-between; gap:12px; min-height:24px; }
.shortcut-error { margin:0; padding:0 16px 10px; color:var(--salt-error,#c44); font-size:12px; }
.shortcut-settings-panel ::v-deep(.salt-ui-item) { min-height:52px; }
.shortcut-settings-panel ::v-deep(.trailing) { margin-left:auto; max-width:48%; }
@media(max-width:600px) { .shortcut-settings-panel ::v-deep(.salt-ui-item) { flex-wrap:nowrap; } .shortcut-settings-panel ::v-deep(.item-copy) { min-width:0; flex:1 1 auto; } .shortcut-settings-panel ::v-deep(.trailing) { flex:0 0 auto; max-width:48%; } }
</style>
